export const clientToolDefinitions = [
  {
    toolId: "tool-find-by-title-tool",
    name: "Find by Title",
    description: "Fetch details about a specific title",
  },
  {
    toolId: "tool-get-available-layers",
    name: "Get Available Layers",
    description: "Fetch details about the available layers",
  },
  {
    toolId: "tool-enable-layers",
    name: "Enable Layers",
    description: "Enable specific layers",
  },
  {
    toolId: "tool-get-selection-details",
    name: "Get Selection Details",
    description: "Fetch details about the current site selection",
  },
  {
    toolId: "tool-get-user-confirmation",
    name: "User Confirmation",
    description: "Check with the user for confirmation",
  },
  {
    toolId: "tool-setSiteSourcingFilters",
    name: "Set site sourcing filters",
    description: "Opens the site sourcing tool and searches.",
  },
  {
    toolId: "tool-set-planning-applications-filter-tool",
    name: "Set planning applications filters",
    description: "Sets the planning applications filters",
  },
  {
    toolId: "tool-openSiteSourcingAndSearch",
    name: "Open Site Sourcing and searches",
    description: "Opens the site sourcing tool and searches.",
  },
] as const;

export const serverToolDefinitions = [
  {
    toolId: "tool-getLandInsightKnowledge",
    name: "Knowledge base",
    description: "Fetches more specific knowledge from our Land Insight knowledge base.",
  },
  {
    toolId: "tool-validateSiteSourcingJson",
    name: "Checking site filters",
    description: "Validates the JSON structure of the site sourcing data.",
  },
  {
    toolId: "tool-lookupLocations",
    name: "Lookup Locations",
    description: "Fetches location details based on the user's input.",
  },
  {
    toolId: "tool-generateSiteSourcingFilters",
    name: "Generate Filters",
    description: "Generates filters",
  },
  {
    toolId: "tool-getSiteSourcingSearchStats",
    name: "Stats for filtered area",
    description: "Fetches filter statistics for a specific area.",
  },
  {
    toolId: "tool-get-planning-application-area-summary-tool",
    name: "Planning application summary",
    description: "Fetches filter statistics for a specific area.",
  },
  {
    toolId: "tool-get-local-planning-authority",
    name: "Local Planning Authority Details",
    description: "Fetches details about the local planning authority for a specific area.",
  },
  {
    toolId: "tool-get-local-planning-authority-plan",
    name: "Local Planning Authority Plan Details",
    description: "Fetches details about the local planning authority plan for a specific area.",
  },
  {
    toolId: "tool-get-use-class-breakdown",
    name: "Use Class Breakdown",
    description: "Fetches details about the use class breakdown for a specific area.",
  },
  {
    toolId: "tool-get-planning-applications-tool",
    name: "Planning Applications",
    description: "Fetches details about planning applications for a specific area.",
  },
  {
    toolId: "tool-local-plan-knowledge-base-lookup",
    name: "Local Plan Lookup",
    description: "Looks up additional information from the local plan.",
  },
];

export const allToolDefinitions = [...clientToolDefinitions, ...serverToolDefinitions] as const;
